import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { useCockpitAccess } from '@/hooks/useCockpitAccess';
import { canAccessCockpit, type Role } from '@/types/navigation';

/** Direct /cockpit URLs use the same predicate as the navigation registry:
 * admin/manager always, traders only with a resolved `cockpitAccess` grant. */
export function CockpitRoute() {
  const role = (useAuthStore((s) => s.user?.role) ?? 'trader') as Role;
  const cockpitAccess = useCockpitAccess();
  return canAccessCockpit(role, cockpitAccess) ? <Outlet /> : <Navigate to="/dashboard" replace />;
}
